/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReadinessIssueDTO } from './readiness-issue-dto';


export interface ExceptionResponseWithDetailsDTO { 
    code?: number;
    message?: string;
    key?: string;
    details?: Array<ReadinessIssueDTO>;
}

